import definedOrThrow from '@/utils/definedOrThrow';

/**
 * The Graph subgraph endpoints
 */

export const subgraphEndpoints = {
  // Token
  AniftyERC1155V1: definedOrThrow(
    process.env.NEXT_PUBLIC_ANIFTY_ERC1155_V1_GRAPH,
    'NEXT_PUBLIC_ANIFTY_ERC1155_V1_GRAPH'
  ),
  AniftyERC1155V2: definedOrThrow(
    process.env.NEXT_PUBLIC_ANIFTY_ERC1155_V2_GRAPH,
    'NEXT_PUBLIC_ANIFTY_ERC1155_V2_GRAPH'
  ),

  // Marketplace
  AniftyMarketplaceV1: definedOrThrow(
    process.env.NEXT_PUBLIC_MARKETPLACE_V1_GRAPH,
    'NEXT_PUBLIC_MARKETPLACE_V1_GRAPH'
  ),
  AniftyMarketplaceV2: definedOrThrow(
    process.env.NEXT_PUBLIC_MARKETPLACE_V2_GRAPH,
    'NEXT_PUBLIC_MARKETPLACE_V2_GRAPH'
  ),
  AniftyMarketplaceV3: definedOrThrow(
    process.env.NEXT_PUBLIC_MARKETPLACE_V3_GRAPH,
    'NEXT_PUBLIC_MARKETPLACE_V3_GRAPH'
  ),
};
